import { useCallback } from 'react';
import ReactGA from 'react-ga4';
export var useAnalytics = function useAnalytics() {
    var trackBookmark = useCallback(function (articleId, isBookmarked) {
        ReactGA.event({
            action: 'bookmark_article',
            category: 'engagement',
            label: articleId,
            value: isBookmarked ? 1 : 0
        });
    }, []);
    var trackPdfDownload = useCallback(function (articleId) {
        ReactGA.event({
            action: 'download_pdf',
            category: 'engagement',
            label: articleId
        });
    }, []);
    var trackShareArticle = useCallback(function (platform) {
        ReactGA.event({
            action: 'share_article',
            category: 'engagement',
            label: platform
        });
    }, []);
    var trackDownloadAudio = useCallback(function (articleId) {
        ReactGA.event({
            action: 'download_audio',
            category: 'engagement',
            label: articleId
        });
    }, []);
    var trackReadAlso = useCallback(function (articleId) {
        ReactGA.event({
            action: 'read_also',
            category: 'engagement',
            label: articleId
        });
    }, []);
    var trackSubNewsletter = useCallback(function (type) {
        ReactGA.event({
            action: 'subscribe_newsletter',
            category: 'engagement',
            label: type
        });
    }, []);
    var trackMenuOpened = useCallback(function () {
        ReactGA.event({
            action: 'menu_opened',
            category: 'engagement',
            label: "Navigation Menu Opened"
        });
    }, []);
    var trackShopOpened = useCallback(function () {
        ReactGA.event({
            action: 'shop_opened',
            category: 'engagement',
            label: "Shop Opened"
        });
    }, []);
    var trackShopItemSelected = useCallback(function (article) {
        ReactGA.event({
            action: 'shop_item_selected',
            category: 'engagement',
            label: "Shop Opened"
        });
    }, []);
    return {
        trackBookmark: trackBookmark,
        trackPdfDownload: trackPdfDownload,
        trackReadAlso: trackReadAlso,
        trackShareArticle: trackShareArticle,
        trackDownloadAudio: trackDownloadAudio,
        trackSubNewsletter: trackSubNewsletter,
        trackMenuOpened: trackMenuOpened,
        trackShopOpened: trackShopOpened,
        trackShopItemSelected: trackShopItemSelected
    };
};
